import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '@/utils/auth'

Vue.use(VueRouter)

const Login = () => import('@/views/login/index.vue')
const Layout = () => import('@/views/layout/index.vue')
const Batch = () => import('@/views/batch/index.vue')
const Item = () => import('@/views/item/index.vue')
const StallArea = () => import('@/views/stall-area/index.vue')
const Stall = () => import('@/views/stall/index.vue')
const User = () => import('@/views/user/index.vue')
const LabelEditor = () => import('@/views/label/index.vue')
const ReturnBatch = () => import('@/views/return-batch/index.vue')
const ReturnItem = () => import('@/views/return-item/index.vue')

const routes = [
  {
    path: '/login',
    component: Login,
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/batch',
    children: [
      {
        path: 'batch',
        component: Batch,
        meta: { title: '批次管理' }
      },
      {
        path: 'item',
        component: Item,
        meta: { title: '明细管理' }
      },
      {
        path: 'stall-area',
        component: StallArea,
        meta: { title: '区域管理' }
      },
      {
        path: 'stall',
        component: Stall,
        meta: { title: '档口管理' }
      },
      {
        path: 'user',
        component: User,
        meta: { title: '账号管理' }
      },
      {
        path: 'label',
        component: LabelEditor,
        meta: { title: '标签设置' }
      },
      {
        path: 'return-batch',
        component: ReturnBatch,
        meta: { title: '退货批次' }
      },
      {
        path: 'return-item',
        component: ReturnItem,
        meta: { title: '退货明细' }
      }
    ]
  },
  // 兜底重定向
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

// 路由守卫：未登录跳转 /login
router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next()
    return
  }
  const token = getToken()
  if (!token) {
    next('/login')
  } else {
    next()
  }
})

export default router
